import { Outlet, Navigate, useParams, useLocation } from "react-router-dom";
import { useSectionNavLinks, buildSectionPeopleListPath } from "../_utils";
import AppLayout from "@/layouts/AppLayout";
import ErrorBoundary from "@/components/ErrorBoundary";
import { useIsCompactLayout } from "@/hooks/useIsCompactLayout";
import Breadcrumb from "@/components/Breadcrumb";
import { useFlags, useFlagsLoaded } from "@/hooks/useFeatureFlags";

export default function SectionPeopleLayout() {
  const { sectionId } = useParams();
  const { pathname, search } = useLocation();
  const { isCompactLayout: isMobile } = useIsCompactLayout();
  const navLinks = useSectionNavLinks(sectionId);
  const flags = useFlags();
  const flagsLoaded = useFlagsLoaded();
  const isSettings = pathname.endsWith("/settings");

  if (!flagsLoaded) {
    return null;
  }

  if (flags["backoffice-section-people"] !== true) {
    if (sectionId && pathname.includes("/change-requests")) {
      const settingsSuffix = isSettings ? "/settings" : "";
      return <Navigate to={`/sections/${sectionId}/change-requests${settingsSuffix}${search}`} replace />;
    }

    return <Navigate to={sectionId ? buildSectionPeopleListPath(sectionId) : "/sections"} replace />;
  }

  if (!sectionId) {
    return (
      <div data-testid="error">
        <ErrorBoundary variant="inline" title="Invalid Page Access" message="Section ID not found" />
      </div>
    );
  }

  return (
    <AppLayout navLinks={navLinks} interior bottomBar>
      {isMobile && !isSettings && (
        <Breadcrumb
          compactOnly
          compactTitle="People"
          backLink={{ to: "/sections/:sectionId", params: { sectionId } }}
        />
      )}
      <Outlet />
    </AppLayout>
  );
}
